import React from 'react';
import {
  Typography,
  TextField,
  IconButton,
  InputAdornment,
  Tooltip,
  Box,
  Button,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useDispatch } from 'react-redux';
import { updateSnackbar } from '../../../_redux/SnackbarSlice';

const JobBoardPreview = ({ settings }) => {
  const {
    logo,
    fontFamily,
    primaryColor,
    secondaryColor,
    primaryFontColor,
    secondaryFontColor,
    useCustomHeader,
    headerBackgroundColor,
    headerTextColor,
  } = settings;
  const dispatch = useDispatch();
  const headerStyle = {
    backgroundColor: useCustomHeader ? headerBackgroundColor : secondaryColor,
    color: useCustomHeader ? headerTextColor : secondaryFontColor,
    fontFamily: fontFamily?.[0] || 'Roboto',
  };
  const handleCopyURL = () => {
    navigator.clipboard.writeText(settings.url);
    dispatch(
      updateSnackbar({
        type: 'success',
        message: 'Job Board Portal URL copied to clipboard!',
      })
    );
  };
  return (
    <>
      {settings.isJobPortal && (
        <>
          <div className="previewSection">
            <header style={headerStyle}>
              <img
                src={logo || process.env.PUBLIC_URL + '/assests/HireWing.png'}
                alt="logo"
                style={{
                  width: '150px',
                  paddingLeft: '30px',
                  objectFit: 'contain',
                }}
              />
              <Typography
                className="jobBoard_menulist"
                sx={{
                  fontFamily: `${fontFamily?.[0] || 'Roboto'} !important`,
                  color: `${headerStyle.color} !important`,
                }}
              >
                Job Feed
              </Typography>
            </header>

            <div
              style={{
                display: 'flex',
                marginTop: '30px',
                fontFamily: fontFamily?.[0] || 'Roboto',
              }}
              className="sidesubmitbtn "
            >
              <div className="squarelinedot">
                <div className="square" style={{ backgroundColor: '#7a7a7a' }}>
                  <div
                    className="vert-line"
                    style={{ borderColor: '#7a7a7a' }}
                  ></div>
                </div>
                <div
                  className="circle"
                  style={{ backgroundColor: primaryColor }}
                ></div>
              </div>

              <div className="displaycard">
                <div className="displaytext">
                  <Typography
                    sx={{
                      fontSize: '19px',
                      fontWeight: 700,
                      fontFamily: `${fontFamily?.[0] || 'Roboto'} !important`,
                    }}
                  >
                    UX Designer
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 17,
                      fontWeight: 400,
                      fontFamily: fontFamily?.[0] || 'Roboto',
                    }}
                  >
                    The Company Media Office - Full Time
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 17,
                      fontWeight: 400,
                      fontFamily: `${fontFamily?.[0] || 'Roboto'} !important`,
                    }}
                  >
                    Location : Ontario
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontWeight: 400,
                      fontFamily: `${fontFamily?.[0] || 'Roboto'} !important`,
                    }}
                  >
                    19 minutes ago
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 17,
                      fontWeight: 400,
                      fontFamily: `${fontFamily?.[0] || 'Roboto'} !important`,
                    }}
                  >
                    5LPA
                  </Typography>

                  <Typography
                    sx={{
                      margin: '20px 0px 10px',
                      fontSize: 20,
                      fontWeight: 700,
                      fontFamily: `${fontFamily?.[0] || 'Roboto'} !important`,
                    }}
                  >
                    {' '}
                    Job Description
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 15,
                      fontWeight: 400,
                      fontFamily: `${fontFamily?.[0] || 'Roboto'} !important`,
                    }}
                  >
                    Do comprehensive user and market research, and create
                    well-formed UX analysis documents. Articulate vision,
                    inspire clients to adopt a design thinking mindset, drive
                    the product strategy, roadmap, and governance.
                  </Typography>
                </div>
              </div>

              <div className="submissionbtn">
                <Button
                  className="btn-submit-candidate"
                  sx={{
                    backgroundColor: primaryColor,
                    color: primaryFontColor,
                    fontFamily: `${fontFamily?.[0] || 'Roboto'} !important`,
                    pointerEvents: 'none',
                  }}
                >
                  Apply Now
                </Button>
              </div>
            </div>
          </div>
          <Box
            mt={3}
            p={2}
            border="1px solid #ccc"
            borderRadius={2}
            bgcolor="#f9f9f9"
            boxShadow="0 2px 6px rgba(0,0,0,0.1)"
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, marginBottom: '8px' }}
            >
              You can preview the changes and access your Job Board Portal using
              the URL below
            </Typography>
            <TextField
              fullWidth
              label="Job Board Portal URL"
              value={settings.url}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Copy to clipboard">
                      <IconButton onClick={handleCopyURL}>
                        <ContentCopyIcon />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{ shrink: true }}
              size="small"
            />
          </Box>
        </>
      )}
      {!settings.isJobPortal && (
        <Box
          sx={{
            border: '1px dashed #e5e5e5',
            padding: 3,
            marginTop: 2,
            textAlign: 'center',
            height: '200px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h6" color="textSecondary">
            The Job Board Portal is currently <strong>disabled</strong>. Enable
            it using the switch above to view and customize the portal.
          </Typography>
        </Box>
      )}
    </>
  );
};

export default JobBoardPreview;
